import { Suspense } from 'react';
import ViewLoader from './ViewLoader.js';

const Loadable = (Component, Loader = ViewLoader) => (props) =>
(
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
);

export default Loadable;